import { Component, OnInit } from '@angular/core';

import { NavMainNode } from '@core/models/nav-main.model';
import { UserProfile } from '@core/models/user-profile.model';

import { NavMainService } from '@core/services/nav-main/nav-main.service';
import { UserProfileService } from '@core/services/user-profile/user-profile.service';

@Component({
  selector: 'fdx-auth-layout',
  templateUrl: './auth-layout.component.html',
  host: { class: 'd-flex flex-column h-100' }
})
export class AuthLayoutComponent implements OnInit {
  navMainNodes: NavMainNode[];
  userProfile: UserProfile;

  constructor(
    private navMainService: NavMainService,
    private userProfileService: UserProfileService
  ) {}

  ngOnInit(): void {
    this.getNavMain();
    this.getUserProfile();
  }

  private getNavMain(): void {
    this.navMainService
      .getAll()
      .subscribe(
        (navMainNodes: NavMainNode[]) => (this.navMainNodes = navMainNodes)
      );
  }

  private getUserProfile(): void {
    this.userProfileService
      .getDetail()
      .subscribe(
        (userProfile: UserProfile) => (this.userProfile = userProfile)
      );
  }
}
